import React, { ChangeEvent, FC, useState } from 'react';
import { hoursLimit, minutesOptions, timeErrors, timeOptions } from '@/const/calendar';
import styles from './styles/index.module.scss';

interface IProps {
  onTimeChange: (time: string) => void,
}

const TimePicker: FC<IProps> = ({ onTimeChange }) => {
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState(minutesOptions[0]);
  const [error, setError] = useState('');

  const validateTime = (value: string, type: string) => {
    switch (type) {
      case timeOptions.hours: {
        const hoursValue = +value;
        if (hoursValue < hoursLimit.min || hoursValue > hoursLimit.max) {
          setError(timeErrors.hours);
          return false;
        }
        break;
      }
      case timeOptions.minutes: {
        if (!minutesOptions.includes(value)) {
          setError(timeErrors.minutes);
          return false;
        }
        break;
      }
      default:
        break;
    }
    setError('');
    return true;
  };

  const handleHourChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (validateTime(value, 'hours')) {
      setHours(value);
      onTimeChange(`${value}:${minutes}`);
    }
  };

  const handleMinuteChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (validateTime(value, 'minutes')) {
      setMinutes(value);
      onTimeChange(`${hours}:${value}`);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrap}>
        <div className={styles.wraper}>
          <label className={styles.field}>
            Час
            <input
              className={styles.input}
              type="number"
              value={hours}
              onChange={handleHourChange}
              min="0"
              max="23"
            />
          </label>
        </div>
        <div className={styles.colon}>:</div>
        <div className={styles.wraper}>
          <label className={styles.field}>
            Мин
            <select
              className={styles.input}
              value={minutes}
              onChange={handleMinuteChange}
              onBlur={handleMinuteChange}
            >
              {minutesOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
                ))}
            </select>
          </label>
        </div>
      </div>
      <div className={styles.error}>{error || ''}</div>
    </div>
  );
};

export default TimePicker;